
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin } from '../../mixins';

@Component
export default class ClipboardSvg extends Mixins(VuetifyMixin){
	@Prop({ default: 25 }) private size: number;
	@Prop({ default: 'baColorVibrantBlue' }) private color: string;
	get Color(){
		return this.getColor(this.color);
	}
}
